import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import { NodeProject } from '../../../../types/uncinc_profile/nodes';

interface NodeProjectProps {
  entity: ImmutableEntity<NodeProject>;
  className?: string;
}

// Project content type. Used for 'Scholen'.
const ProjectTeaser: React.FC<NodeProjectProps> = ({ entity, className = '', ...props }) => {
  const { t } = useTranslation();
  const langcode = entity.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);

  const classes = classNames('NodeProject', 'NodeProject--teaser', className);
  const node = entity.toJS();

  const title = node.title[0].value;
  const status = node.field_status[0].entity.name[0].value || null;
  const types = node.field_type.map(({ entity: term }) => term.name[0].value);
  const url = entity.getIn(['paths', langcode], '');

  return (
    <div className={classes} {...props}>
      <h3>{title}</h3>
      <p>
        {status}<br />
        {types.join(', ')}
      </p>
      <Button href={url} primary>{t('pages.node_project.more_info')} &gt;</Button>
    </div>
  );
};

export default ProjectTeaser;
